module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<div class='tooltip-inner-wrapper tooltip-line-chart'>\n  <div class='current-wrapper'>\n    <div class='association'><var>" + this.currentDate + "</var>:</div>\n    <div class='data'>");
      if (this.sampleSize) {
        $o.push("      <span class='value'>" + this.currentValue + " " + this.currentDisplayUnits + " (" + this.sampleSize + " " + this.sampleSizeUnits + ")</span>");
      } else {
        $o.push("      <span class='value'>" + this.currentValue + " " + this.currentDisplayUnits + "</span>");
      }
      if (this.change != null) {
        $o.push("      <span class='" + (['percentage', "" + ($e($c(this.changeDirection)))].sort().join(' ').replace(/^\s+|\s+$/g, '')) + "'>");
        $o.push("        " + $e($c(this.change)));
        $o.push("      </span>");
      }
      $o.push("    </div>\n  </div>");
      if (this.priorValue) {
        $o.push("  <div class='prior-wrapper'>\n    <div class='association'><var>" + this.priorDate + "</var>:</div>\n    <div class='data'>\n      <span class='value'>" + this.priorValue + " " + this.priorDisplayUnits + "</span>\n    </div>\n  </div>");
      }
      $o.push("</div>");
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "").replace(/[\s\n]*\u0091/mg, '').replace(/\u0092[\s\n]*/mg, '');
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/shared/templates/chartist/line_chart_tooltip.js.hamlc
// module id = 1638
// module chunks = 10